// THIS NEED TO BE TEST
export const serverURL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : "https://devserver.chapterme.co";
